module.exports = __webpack_public_path__ + "b42414f7b418c2b5114cce0611bf7e54.svg";